import { EmptyStateProps } from 'owa-empty-state/lib/components/EmptyState';
import {
    flaggedEmailTaskListEmptyStatePrimaryText,
    myDayTaskListEmptyStateSecondaryText,
    myDayTaskListEmptyStatePrimaryText,
    taskListErrorEmptyStateSecondaryText,
    taskListErrorEmptyStatePrimaryText,
} from './getEmptyStateProps.locstring.json';
import { getIsLightBaseTheme } from 'owa-theme';
import loc from 'owa-localize';
import { assertNever } from 'owa-assert';

/**
 * initialize the svgs icons
 */
let EMPTY_STATE_FLAGGED;
let ERROR_STATE;
let EMPTY_STATE_MYDAY;

function initializeDisplayIconsForEmptyList() {
    if (getIsLightBaseTheme()) {
        // colored svgs that goes with the blue base theme
        EMPTY_STATE_MYDAY = require('owa-empty-state/lib/svg/colored/emptyTaskList.svg');
        ERROR_STATE = require('owa-empty-state/lib/svg/colored/loadingError.svg');
        EMPTY_STATE_FLAGGED = require('owa-empty-state/lib/svg/colored/emptyFlaggedEmailTaskList.svg');
    } else {
        // gray scale svgs
        ERROR_STATE = require('owa-empty-state/lib/svg/gray/loadingError.svg');
        EMPTY_STATE_MYDAY = require('owa-empty-state/lib/svg/gray/emptyTaskList.svg');
        EMPTY_STATE_FLAGGED = require('owa-empty-state/lib/svg/gray/emptyFlaggedEmailTaskList.svg');
    }
}
export type ListType = 'MyDay' | 'FlaggedEmail' | 'Error';

export function getEmptyStateProps(listType: ListType): EmptyStateProps {
    initializeDisplayIconsForEmptyList();
    if (listType === 'MyDay') {
        return {
            icon: EMPTY_STATE_MYDAY,
            detailMessage: loc(myDayTaskListEmptyStateSecondaryText),
            mainMessage: loc(myDayTaskListEmptyStatePrimaryText),
        };
    } else if (listType === 'FlaggedEmail') {
        return {
            icon: EMPTY_STATE_FLAGGED,
            mainMessage: loc(flaggedEmailTaskListEmptyStatePrimaryText),
        };
    } else if (listType === 'Error') {
        return {
            icon: ERROR_STATE,
            detailMessage: loc(taskListErrorEmptyStateSecondaryText),
            mainMessage: loc(taskListErrorEmptyStatePrimaryText),
        };
    } else {
        return assertNever(listType);
    }
}
